/* Brand film (click-to-load video) and recipe reels (tap-to-play carousel). No video bytes load before a click. */
(function () {
  function loadFilm(root) {
    var card = root.querySelector('.trq-film__card');
    if (!card || card.classList.contains('is-playing')) return;
    var media = card.querySelector('.trq-film__media');
    var yt = card.dataset.youtube;
    var vimeo = card.dataset.vimeo;
    if (yt || vimeo) {
      var f = document.createElement('iframe');
      f.src = yt
        ? 'https://www.youtube-nocookie.com/embed/' + yt + '?autoplay=1&rel=0&playsinline=1&modestbranding=1'
        : 'https://player.vimeo.com/video/' + vimeo + '?autoplay=1';
      f.title = card.dataset.title || '';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      media.appendChild(f);
    } else {
      var tpl = card.querySelector('template');
      if (!tpl) return;
      media.appendChild(tpl.content.cloneNode(true));
      var v = media.querySelector('video');
      if (v) { v.controls = true; v.play().catch(function () {}); }
    }
    card.classList.add('is-playing');
    root.querySelectorAll('[data-trq-play]').forEach(function (b) { b.setAttribute('aria-pressed', 'true'); });
  }

  if (!customElements.get('trq-film')) {
    customElements.define('trq-film', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.querySelectorAll('[data-trq-play]').forEach(function (b) {
          b.addEventListener('click', function () {
            var card = self.querySelector('.trq-film__card');
            if (b.classList.contains('trq__btn') && card) {
              var r = card.getBoundingClientRect();
              if (r.top < 0 || r.bottom > window.innerHeight) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            loadFilm(self);
          });
        });
      }
    });
  }

  if (!customElements.get('trq-reels')) {
    customElements.define('trq-reels', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.trq-reels__track');
        this.reels = Array.prototype.slice.call(this.querySelectorAll('.trq-reel'));
        this.prev = this.querySelector('[data-trq-prev]');
        this.next = this.querySelector('[data-trq-next]');
        this.dots = Array.prototype.slice.call(this.querySelectorAll('.trq-reels__dot'));
        var self = this;
        this.reels.forEach(function (reel) {
          reel.querySelector('.trq-reel__play').addEventListener('click', function () { self.toggle(reel); });
          var mute = reel.querySelector('.trq-reel__mute');
          if (mute) mute.addEventListener('click', function () {
            var v = reel.querySelector('video');
            if (!v) return;
            v.muted = !v.muted;
            mute.setAttribute('aria-pressed', v.muted ? 'true' : 'false');
          });
        });
        if (this.prev) this.prev.addEventListener('click', function () { self.step(-1); });
        if (this.next) this.next.addEventListener('click', function () { self.step(1); });
        this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.goTo(i); }); });
        this.track.addEventListener('scroll', function () { window.requestAnimationFrame(function () { self.sync(); }); }, { passive: true });
        this.sync();
        this.inView = true;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              self.inView = e.isIntersecting;
              if (!e.isIntersecting) self.pauseAll();
            });
          }, { threshold: 0.25 }).observe(this);
        }
        this.initAuto();
      }
      initAuto() {
        var secs = parseFloat(this.dataset.autoslide);
        if (!secs || this.reels.length < 2) return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var self = this;
        this.autoBtn = this.querySelector('[data-trq-auto]');
        this.userPaused = false;
        this.hold = { hover: false, focus: false, touch: false };
        if (this.autoBtn) {
          this.autoBtn.hidden = false;
          this.autoBtn.addEventListener('click', function () {
            self.userPaused = !self.userPaused;
            self.autoBtn.setAttribute('aria-pressed', self.userPaused ? 'true' : 'false');
            self.autoBtn.setAttribute('aria-label', self.userPaused ? self.autoBtn.dataset.labelPlay : self.autoBtn.dataset.labelPause);
          });
        }
        this.addEventListener('mouseenter', function () { self.hold.hover = true; });
        this.addEventListener('mouseleave', function () { self.hold.hover = false; });
        this.addEventListener('focusin', function () { self.hold.focus = true; });
        this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) self.hold.focus = false; });
        var release;
        var touchStart = function () { self.hold.touch = true; clearTimeout(release); };
        var touchEnd = function () { clearTimeout(release); release = setTimeout(function () { self.hold.touch = false; }, secs * 1000); };
        this.track.addEventListener('touchstart', touchStart, { passive: true });
        this.track.addEventListener('touchend', touchEnd, { passive: true });
        this.track.addEventListener('pointerdown', touchStart);
        this.track.addEventListener('pointerup', touchEnd);
        this.timer = setInterval(function () { self.tick(); }, secs * 1000);
      }
      tick() {
        if (this.userPaused || document.hidden || !this.inView) return;
        if (this.hold.hover || this.hold.focus || this.hold.touch) return;
        if (this.querySelector('.trq-reel.is-playing')) return;
        var t = this.track;
        if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 4) this.goTo(0);
        else this.step(1);
      }
      itemWidth() { var r = this.reels[0]; return r ? r.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : 1; }
      step(dir) { this.track.scrollBy({ left: dir * this.itemWidth(), behavior: 'smooth' }); }
      goTo(i) { this.track.scrollTo({ left: i * this.itemWidth(), behavior: 'smooth' }); }
      sync() {
        var t = this.track, idx = Math.round(t.scrollLeft / this.itemWidth());
        this.dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
        if (this.next) this.next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
      }
      pauseAll(except) {
        this.reels.forEach(function (r) {
          if (r === except) return;
          var v = r.querySelector('video');
          if (v) v.pause();
          r.classList.remove('is-playing', 'is-active');
          r.querySelector('.trq-reel__play').setAttribute('aria-pressed', 'false');
        });
      }
      toggle(reel) {
        var btn = reel.querySelector('.trq-reel__play');
        var v = reel.querySelector('video');
        if (v && !v.paused) {
          v.pause();
          reel.classList.remove('is-playing');
          btn.setAttribute('aria-pressed', 'false');
          return;
        }
        this.pauseAll(reel);
        if (!v) {
          var tpl = reel.querySelector('template');
          if (!tpl) return;
          reel.querySelector('.trq-reel__card').insertBefore(tpl.content.cloneNode(true), btn);
          v = reel.querySelector('video');
          v.addEventListener('ended', function () { reel.classList.remove('is-playing'); btn.setAttribute('aria-pressed', 'false'); });
        }
        v.muted = false;
        var mute = reel.querySelector('.trq-reel__mute');
        if (mute) mute.setAttribute('aria-pressed', 'false');
        v.play().catch(function () { v.muted = true; if (mute) mute.setAttribute('aria-pressed', 'true'); v.play().catch(function () {}); });
        reel.classList.add('is-playing', 'is-active');
        btn.setAttribute('aria-pressed', 'true');
      }
    });
  }
})();
